module.exports = __webpack_public_path__ + "static/media/down-arrow.4f1c04e6.svg";